import styles from './contract-status.module.scss';
import { Divider } from '@mui/material';
import Card, { CardContent } from '../../card/card';
import { toCurrency } from '../../table-helpers/table-helpers';
import { IContractInfo, Typography, TextField, useSingleContractDispatch, SecondaryButton } from '@frontend-workspace/react-shared-lib';
import { format } from 'date-fns';
import { t } from 'i18next';

/* eslint-disable-next-line */
export interface ContractStatusProps {
  contractInfo: IContractInfo,
  recurringDisount: number,
  nextInvoiceCost: number,
  onOpenMoveInvoice: () => void
}

export function ContractStatus(props: ContractStatusProps) {
  const dispatch = useSingleContractDispatch();
  const handleNextInvoiceChange = (value: any) => {
    dispatch({ type: "NEXT_INVOICE_DATE_CHANGE", newDate: value });
  }
  return (
    <Card className='mt-3 mb-4'>
      <CardContent>
        <Typography
          variant="h4"
          component="div"
          className="mb-4">
          {t("standard.paymentOverview")}
        </Typography>
        <div className="d-flex flex-row flex-wrap mb-3">
          <TextField
            label={t("standard.renewalDate")}
            value={`${format(new Date(props.contractInfo.nextInvoicingDate), "dd.MM.yyyy")}`}
            disabled
            className='me-3'
          />
          {/* TODO commented out in case we want to roll back from SalesForce. Remove if this is not needed */}
          {/* <div className='d-flex align-items-end'>
            <SecondaryButton
              onClick={props.onOpenMoveInvoice}
              variant='outlined'
              className='mt-2'>
              {t("standard.moveInvoiceDate")}
            </SecondaryButton>
          </div> */}
        </div>
        <div className="d-flex flex-row mb-2 MuiTypography-body4">
          <div className='me-auto'>{t("standard.totalBeforeDiscount")}</div>
          <div>{toCurrency(props.recurringDisount + props.nextInvoiceCost, props.contractInfo.currency)}</div>
        </div>
        <Divider className='mb-2' />
        <div className="d-flex flex-row mb-2 MuiTypography-body4">
          <div className='me-auto'>{t("standard.recurringDiscount")}</div>
          <div>{toCurrency(props.recurringDisount, props.contractInfo.currency)}</div>
        </div>
        <Divider className='mb-2' />
        <div className="d-flex flex-row mb-2 MuiTypography-subtitle3">
          <div className='me-auto'>{t("standard.totalInvoiceAmount")}</div>
          <div>{toCurrency(props.nextInvoiceCost, props.contractInfo.currency)}</div>
        </div>
      </CardContent>
    </Card>
  )
}

export default ContractStatus;